import { useState } from "react";
import { useNavigate } from 'react-router-dom';
import { useSWRConfig } from 'swr';
import { useDispatch } from 'react-redux';
import { axiosApiInstance } from '../../../services/axios';

import LoginForm from '../../common/forms/auth/LoginForm';
import { updateUser } from '../../../redux/slices/auth';

function Login() {
  const { cache, mutate } = useSWRConfig();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [btnLoading, setBtnLoading] = useState(false);

  const changeBtnLoading = (state) => {
    setBtnLoading(state);
  };

  const reDirect = async () => {
    cache.clear();

    try {
      // Verify that the browser stored the auth cookie before leaving the login page.
      const response = await axiosApiInstance.get('/admin/profile');

      if (response?.data?.status !== 'success' || !response?.data?.data) {
        throw new Error('Login succeeded, but the admin session could not be verified.');
      }

      // Seed the SWR cache and Redux so protected routes render immediately.
      mutate('user_me', response, false);
      dispatch(updateUser({
        user: response.data.data,
        loading: false,
        error: null
      }));

      navigate('/', { replace: true });
    } catch (error) {
      dispatch(updateUser({
        user: null,
        loading: false,
        error
      }));
      throw error;
    }
  };

  return (
    <>
      <div className='h-screen bg-background-100 w-full flex justify-center items-center p-5'>
        <div className='shadow-lg w-full bg-white-100 p-8 rounded-3xl max-w-[500px] text-base'>
          <p className="mb-5 text-[1.2rem] text-gray-600 font-bold ml-1">Login</p>
          <LoginForm reDirec={reDirect} btnLoading={btnLoading} changeBtnLoading={changeBtnLoading} />
        </div>
      </div>
    </>
  );
}

export default Login;
